module.exports = __webpack_public_path__ + "images/stickers/pete-completed.68aead4d41f9f4aed7b7.png";